export enum CrusadeRequisitionTypes {
   IncreaseSupplyLimit = 0,
   AffectsCrusadeCard = 1,
}
